import React from "react";
import { Link } from "gatsby";
import { Calendar, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { newsArticles } from "@/data/newsArticles";

const NewsAndArticlesIndex = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-neutral-800 mb-4">News and Articles</h1>
          <p className="text-lg text-neutral-700">
            Educational resources from Y3 Smiles Dental. All content is general in nature and does not replace a
            personalised clinical assessment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {newsArticles.map((article) => (
            <Card key={article.slug} className="border border-primary/10 shadow-soft hover:shadow-medium transition-all">
              <CardContent className="p-6 flex flex-col h-full">
                <div className="flex items-center gap-2 text-sm text-neutral-600 mb-3">
                  <Calendar className="w-4 h-4 text-primary" />
                  <span>{article.date}</span>
                </div>
                <h2 className="text-xl font-semibold text-neutral-800 mb-3">{article.title}</h2>
                <p className="text-neutral-700 mb-6 flex-grow">{article.excerpt}</p>
                <Button variant="outline" asChild>
                  <Link to={`/news-and-articles/${article.slug}`}>
                    Read article
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Link>
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsAndArticlesIndex;
